import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ManagerDashboard from "@/pages/ManagerDashboard";
import ManagerRoster from "@/pages/ManagerRoster";
import ManagerSales from "@/pages/ManagerSales";
import ManagerFoodCost from "@/pages/ManagerFoodCost";
import AdminEntries from "@/pages/AdminEntries";
import AdminSales from "@/pages/AdminSales";
import AdminProfit from "@/pages/AdminProfit";
import AdminStores from "@/pages/AdminStores";
import AdminManagers from "@/pages/AdminManagers";
import { Toaster } from "sonner";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-zinc-500 text-sm tracking-wide">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin/entries" : "/manager"} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin/entries" : "/manager"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/manager" element={<ManagerDashboard />} />
            <Route path="/manager/sales" element={<ManagerSales />} />
            <Route path="/manager/food-cost" element={<ManagerFoodCost />} />
            <Route path="/manager/roster" element={<ManagerRoster />} />
            <Route path="/admin/entries" element={<Protected role="admin"><AdminEntries /></Protected>} />
            <Route path="/admin/sales" element={<Protected role="admin"><AdminSales /></Protected>} />
            <Route path="/admin/profit" element={<Protected role="admin"><AdminProfit /></Protected>} />
            <Route path="/admin/stores" element={<Protected role="admin"><AdminStores /></Protected>} />
            <Route path="/admin/managers" element={<Protected role="admin"><AdminManagers /></Protected>} />
          </Route>
          <Route path="/" element={<RootRedirect />} />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
